import React from "react";
import "./style.scss";

const NoAccessPage = (props) => {
  return (
    <div className="container-fluid search-form-container">
      <div className="noAccess_header text-center">Access Denied</div>
      <div className="noAccess_info text-center">
        You do not have required permissions to access the Floorcovering Hub.
      </div>
    </div>
  );
};
export default NoAccessPage;
